export enum BadgeName {
    HIGH_RATE = 'HIGH_RATE',
    TRENDING_NOW = 'TRENDING_NOW',
    SPECIAL_DISCOUNT = 'SPECIAL_DISCOUNT',
    TOP_BOOK_NEARBY = 'TOP_BOOK_NEARBY',
    SELL_FAST = 'SELL_FAST',
    FEATURE = 'FEATURE',
    HOT_DEAL = 'HOT_DEAL',
    EXCLUSIVE_DEAL = 'EXCLUSIVE_DEAL',
    POPULAR_NEARBY = 'POPULAR_NEARBY',
    RECOMMEND = 'RECOMMEND'
  }
  